import { PassportIcon } from '@/src/assets/icons/PassportIcon'
import ChevronWithIcon from '@/src/common/components/ChevronWithIcon'
import { startCase } from 'lodash'
import { ComponentProps } from 'react'

type ChevronWithIconProps = ComponentProps<typeof ChevronWithIcon>

interface DocumentRowProps
  extends Partial<Omit<ChevronWithIconProps, 'text' | 'caption'>>,
    Pick<ChevronWithIconProps, 'caption'> {
  fileName: string
}

export function DocumentRow(props: DocumentRowProps) {
  return (
    <ChevronWithIcon
      segmentAction="User Pressed the Document Upload Item"
      Icon={<PassportIcon />}
      text={startCase(props.fileName.toLowerCase())}
      {...props}
    />
  )
}
